import { useCallback, useRef } from 'react';

import { ReceiptService } from '../services/receipts';
import { useService } from './use-service';

export type EngagementEventType =
  | 'buyup_engaged'
  | 'exception_logs_engaged'
  | 'sales_journal_engaged';

/**
 * Returns a one-shot trigger that records a qualified engagement event for
 * the onboarding timeline. The trigger fires at most once per component
 * mount; navigation away + back creates a fresh mount and a fresh ref. See
 * docs/superpowers/specs/2026-05-03-onboarding-timeline-design.md for the
 * "first qualified action per mount" rationale.
 */
export function useEngagement(eventType: EngagementEventType, storeId: string) {
  const fired = useRef(false);
  const receiptService = useService(ReceiptService);

  return useCallback(
    (payload?: Record<string, unknown>) => {
      if (fired.current) {
        return;
      }

      fired.current = true;
      void receiptService.recordEngagement(storeId, eventType, payload);
    },
    [eventType, storeId, receiptService]
  );
}
